import { useState, useRef } from 'react';
import { DatePicker } from './forms';
import { DateTime } from 'luxon';
import { Translate, useTranslate } from '~/i18n';

interface DateRangePickerProps {
   onSubmitDates: (dates: any) => void;
}

const DateRangePicker = ({ onSubmitDates }: DateRangePickerProps) => {
   const { translate } = useTranslate();
   const [dateRange, setDateRange] = useState<any>([null, null]);
   const datePickerRef = useRef<any>();
   const [startDate, endDate] = dateRange;
   const presetDates = [
      {
         title: <Translate id="common:today" />,
         startDate: new Date(),
         endDate: new Date(),
      },
      {
         title: <Translate id="common:last 7 days" />,
         startDate: DateTime.now().minus({ days: 7 }).toJSDate(),
         endDate: new Date(),
      },
      {
         title: <Translate id="common:last month" />,
         startDate: DateTime.now().minus({ months: 1 }).toJSDate(),
         endDate: new Date(),
      },
   ];

   const MyContainer = ({ children }: any) => {
      return (
         <div className="">
            <div className=" flex ">
               <div className=" flex flex-col border-r">
                  {presetDates.map(({ startDate, endDate, title }: any) => (
                     <button
                        className="text-sm mx-5  first:mt-9 my-3 text-gray-700 whitespace-nowrap text-left font-semibold"
                        onClick={() => setDateRange([startDate, endDate])}
                        type="button"
                        key={title}>
                        {title}
                     </button>
                  ))}
               </div>

               <div className="relative">{children}</div>
            </div>
            <div className="flex justify-end py-3 border-t">
               <button
                  onClick={() => datePickerRef?.current?.setOpen(false)}
                  className=" text-sm  font-medium "
                  type="button">
                  <Translate id="common:cancel" />
               </button>
               <button
                  onClick={() => (
                     onSubmitDates([
                        DateTime.fromJSDate(new Date(startDate)).toFormat('yyyy-MM-dd'),
                        DateTime.fromJSDate(new Date(endDate)).toFormat('yyyy-MM-dd'),
                     ]),
                     datePickerRef?.current?.setOpen(false)
                  )}
                  className="mx-5 text-[#0552BC] text-sm  font-semibold"
                  type="button">
                  <Translate id="common:apply" />
               </button>
            </div>
         </div>
      );
   };
   return (
      <div>
         <DatePicker
            placeholderText={translate({ id: 'common:select date' })}
            selected={endDate || startDate}
            startDate={startDate}
            endDate={endDate}
            dateFormat={'PP'}
            onChange={(update: any) => {
               setDateRange(update);
            }}
            selectsRange
            pickerRef={datePickerRef}
            monthsShown={2}
            popperClassName="ring-1 ring-gray-200 rounded-2xl overflow-hidden bg-white  shadow-2xl  mt-2"
            calendarContainer={MyContainer}
            shouldCloseOnSelect={false}>
            {/* */}
         </DatePicker>
      </div>
   );
};

export default DateRangePicker;
